import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

import { authenticatedRoute } from '@/app/routes/authenticated'

export const exportsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/exports',
  validateSearch: (search) =>
    z.object({ page: z.number().int().positive().optional().catch(undefined) }).parse(search),
  component: lazyRouteComponent(() => import('./pages/exports-page'), 'ExportsPage'),
})
